import http from "./httpService";
import auth from "./authService";
import { Setting } from "../interface/api/Setting";

http.setJwt(auth.getJwt());

export const getSetting = () => {
  return http.get(`/api/setting`);
};

// Administrator only — enforced server-side in SettingController.
export const updateSetting = (setting: Setting) => {
  return http.put(`/api/setting`, setting);
};

export default {
  getSetting,
  updateSetting,
};
